import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class DeviceDeepProfileAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'deviceDeepProfile';

	aiReport(id) {
		let request = {
			url: [this.getAPIUrl(), id, 'ai-report'].join('/'),
		};

		return httpClient.getAsync(request);
	}

	getLastResult(id) {
		let request = {
			url: [this.getAPIUrl(), id, 'last-result'].join('/'),
		};

		return httpClient.getAsync(request);
	}

	getResult(id) {
		let request = {
			url: [this.getAPIUrl(), id, 'result'].join('/'),
		};

		return httpClient.getAsync(request);
	}
}

export default new DeviceDeepProfileAPI();
